import { render, staticRenderFns } from "./CookieConsentMessage.vue?vue&type=template&id=2f357ec0&scoped=true"
import script from "./CookieConsentMessage.vue?vue&type=script&lang=ts"
export * from "./CookieConsentMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f357ec0",
  null
  
)

export default component.exports